import { Experiment } from '@amplitude/experiment-js-client'

export const experiment = Experiment.initialize(process.env.VUE_APP_EXPERIMENTS_KEY)
